<template>
    <!-- 私教课程价格设定 -->
    <el-dialog
        class="course-price-dialog"
        :visible.sync="visible"
        :title="$t('Course.personal_price')"
        left>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :status-icon="true"
            label-position="right"
            label-width="100px"
            label-suffix=":">
            <div>
                <el-form-item :label="$t('Course.name')">
                    {{ lessonName }}
                </el-form-item>
                <el-form-item :label="$t('Sell.sell_store')" prop="storeId">
                    <el-select
                        class="private-course-price-select"
                        v-model="form.storeId"
                        :placeholder="$t('Choose.sell_store')">
                        <el-option
                            v-for="(item, index) in stores"
                            :key="`${index}-${item.id}`"
                            :label="item.name"
                            :value="Number(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Member.price_level')" prop="priceLevel">
                    <el-select
                        class="private-course-price-select"
                        v-model="form.priceLevel"
                        :placeholder="$t('Choose.price_level')">
                        <el-option
                            v-for="(item, index) in level"
                            :key="index"
                            :label="item.name"
                            :value="Number(item.code)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Lesson.count_to')" prop="countTo">
                    <el-input
                        class="course-num-input"
                        type="number"
                        v-model="form.countFrom"></el-input>
                        &nbsp; {{ $t('Reception.Third.zhi') }} &nbsp;
                    <el-input
                        class="course-num-input"
                        type="number"
                        v-model.number="form.countTo"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Sell.Pay.money')" prop="normalPrice">
                    <el-input
                        class="course-num-input"
                        type="number"
                        v-model.number="form.normalPrice">
                    </el-input> &nbsp;{{ $t('Lesson.money') }}
                </el-form-item>
                <!-- <el-form-item label="售卖低价">
                    <el-input
                        class="course-num-input"
                        type="number"
                        v-model.number="form.minprice"></el-input> &nbsp;元/节
                </el-form-item> -->
                <el-form-item
                    :label="$t('Reception.Fifth.transfer')"
                    prop="transferFee">
                    <el-select
                        class="course-num-input methods-select"
                        v-model="form.transferType"
                        :placeholder="$t('Common.please_choose')">
                        <el-option
                            :label="$t('Reception.Fifth.bai')"
                            value="1">
                        </el-option>
                        <el-option
                            :label="$t('Reception.Fifth.amt')"
                            value="2">
                        </el-option>
                    </el-select>
                    <el-input
                        class="course-num-input"
                        type="number"
                        v-model.number="form.transferFee"
                        :placeholder="Number(form.transferType) == 2
                        ? $t('Reception.Fifth.amt_placeholder') : $t('Reception.Fifth.bai_placeholder')">
                    </el-input>
                    &nbsp; {{ Number(form.transferType) == 2 ? $t('Reception.Fifth.yuan') : '%' }}
                </el-form-item>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">{{ $t('Common.close') }}</el-button>
            <el-button @click="confirm" type="primary">{{ $t('Common.save') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { Dialog, Radio, DatePicker, Tree } from 'element-ui';
import FileUpload from '@/components/base/FileUpload.vue';

export default {
    name: 'add-course-price',
    components: {
        ElDialog: Dialog,
        ElRadio: Radio,
        ElTree: Tree,
        ElDatePicker: DatePicker,
        FileUpload,
    },
    data() {
        return {
            form: {
                lessonId: null,
                storeId: null,
                priceLevel: 1,
                countFrom: null, // 数量区间(左)
                countTo: null, // 数量区间(右)
                normalPrice: null, // 常规售价(元/节)
                transferType: '1', /* 转让类型(1-百分比,2-固定金额) */
                transferFee: null, // 转让手续费
            },
            lessonName: null,
            visible: false,
            stores: [],
            storeIds: [],
            rules: {
                storeId: { required: true, type: 'number' },
                priceLevel: { required: true, type: 'number' },
                // countTo: { required: true, type: 'number', message: '请输入数量区间' },
                normalPrice: { required: true, type: 'number', message: this.$t('Fill.sell_price') },
                // transferFee: { required: true, type: 'number', message: '请输入转让手续费' },
            },
            level: [],
            // 当前价格设定的id
            priceId: null,
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            // 清空form数据
            this.$refs.form.resetFields();
            this.stores = [];
            this.storeIds = [];
            this.priceId = null;
            this.form.countFrom = null;
            this.form.transferType = '1';
        },
        open(name, storeId, lessonId, priceId) {
            if (priceId) {
                this.priceId = priceId;
                this.fetchDetails();
            }
            // 获取私教课程详情
            this.lessonName = name;
            this.form.storeId = storeId;
            this.form.lessonId = lessonId;
            this.fetchLesson();
            this.fetchLevel();
            this.visible = true;
        },
        fetchDetails() {
            API.get(`lesson/coach/price/${this.priceId}`).then(res => {
                res.normalPrice = Number(res.normalPrice);
                res.transferFee = Number(res.transferFee);
                res.transferType = (res.transferType).toString();
                this.form = res;
            }).catch(() => {}).finally(() => {});
        },
        fetchLesson() {
            API.get(`lesson/coach/${this.form.lessonId}`).then(res => {
                this.storeIds = res.storeIds;
                this.fetchStore();
            }).catch(err => {
                console.log(err);
            }).finally(() => {});
        },
        async fetchStore() {
            /* let data = {}; */
            await API.get('store/list').then(res => {
                res.forEach(el => {
                    this.storeIds.map(item => {
                        if (item === el.id) this.stores.push(el);
                        return item;
                    });
                });
            });
            this.form.storeId = this.form.storeId || this.stores[0].id;
        },
        fetchLevel() {
            API.get('constant/lesson').then(res => {
                this.level = res.lessonPriceLevel;
                this.form.priceLevel = res.lessonPriceLevel[0].code;
            });
        },
        confirm() {
            const transferFee = {
                transferFee: {
                    type: 'number',
                    required: true,
                    message: this.$t('Reception.Fifth.transfer_placeholder'),
                },
            };
            this.rules = Object.assign({}, this.rules, transferFee);
            const countTo = {
                countTo: {
                    required: true,
                    type: 'number',
                    message: this.$t('Fill.acount_rang'),
                },
            };
            this.rules = Object.assign({}, this.rules, countTo);
            this.$refs.form.validate((valid) => {
                if (!valid || (valid && !this.form.countFrom)
                || (valid && !this.form.countTo)) return false;
                this.handlePost();
            });
        },
        handlePost() {
            let request;
            const form = Object.assign({}, this.form);
            if (!this.priceId) request = API.post('lesson/coach/price', form);
            else request = API.put(`lesson/coach/price/${this.priceId}`, form);
            request.then(() => {
                $ele.$message.success(this.$t('Message.setting_price'));
                this.$emit('fetchData');
                this.visible = false;
            }).catch(() => {});
        },
    },
};
</script>
<style lang="scss">
.course-price-dialog {
    .el-dialog {
        width: 540px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        overflow-y: auto;
    }
}
.el-dialog--center .el-dialog__body {
    padding: 25px 25px 0 25px;
}
.course-num-input {
    width: 110px;
}
.methods-select {
    margin-right: 6px;
    width: 140px;
}
</style>
